import type { InputFormatter } from "../types";

export interface OtpFormatterConfig {
  /** Maximum length of the OTP code (default: 6) */
  length: number;
}

/**
 * OTP formatter - digits only, with configurable max length.
 * Useful for verification codes, PINs, etc.
 */
export const otpFormatter: InputFormatter<OtpFormatterConfig> = {
  format: (value, config) => {
    const digitsOnly = value.replace(/\D/g, "");
    const maxLength = config?.length ?? 6;
    return digitsOnly.slice(0, maxLength);
  },
  parse: (input, config) => {
    const digitsOnly = input.replace(/\D/g, "");
    const maxLength = config?.length ?? 6;
    return digitsOnly.slice(0, maxLength);
  },
  keyboardType: "number-pad",
  autoCapitalize: "none",
};
